import { action } from 'typesafe-actions';
import ActionTypes from 'store/oauth/actionTypes';
import { RequestStatus } from 'types';
import { Token, Introspect } from 'store/oauth/types';

// Reset reducer
export const resetState = () => action(ActionTypes.RESET_STATE);

export const resetToken = () => action(ActionTypes.RESET_TOKEN);

// Set reducer
export const setToken = (payload: Token) =>
  action(ActionTypes.SET_TOKEN, payload);

export const setGettingToken = (payload: boolean) =>
  action(ActionTypes.GETTING_TOKEN, payload);

export const setIntrospect = (payload: Introspect) =>
  action(ActionTypes.SET_INTROSPECT, payload);

// Requests
export const getTokenRequest = () => action(ActionTypes.GET_TOKEN_REQUEST);

export const getIntrospectRequest = () =>
  action(ActionTypes.GET_INTROSPECT_REQUEST);

// Requests status
export const setGetTokenRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GET_TOKEN_REQUEST_STATUS, payload);

export const setGetIntrospectRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GET_INTROSPECT_REQUEST_STATUS, payload);

// Forbidden access
export const setForbiddenAccess = (payload: string) =>
  action(ActionTypes.FORBIDDEN_ACCESS, payload);
